import { render, staticRenderFns } from "./ExcFooterNav.vue?vue&type=template&id=7ae25f5b&scoped=true&"
import script from "./ExcFooterNav.vue?vue&type=script&lang=js&"
export * from "./ExcFooterNav.vue?vue&type=script&lang=js&"
import style0 from "./ExcFooterNav.vue?vue&type=style&index=0&id=7ae25f5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae25f5b",
  null
  
)

export default component.exports